import styled from 'styled-components'

export const HeaderIconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	margin-top: 20px;
	margin-bottom: 20px;

	svg {
		max-width: 100%;
	}
`
